import hyperdom from 'hyperdom'

export default function baggageNotes (model) {
  if (model.config.showBaggageNotes) {
    return <span class="baggage-notes u-margin-left-tiny">
          For more information regarding free baggage allowance and/or the applicable fee for a carry on bag and first and second checked bag, please check the requirements with your individual airline.
    </span>
  }
}
